"use client";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { usePathname } from "next/navigation";
import { countryList } from "@/lib/data";

const GoogleTranslate = () => {
  const scriptRef = useRef();
  const translateRef = useRef();
  const { language } = useSelector((state) => state?.app);
  const pathname = usePathname();

  let getLanguage = () => {
    const countryCode = pathname.substring(1);
    const country = countryList.find((country) => country.name === countryCode);

    if (country) {
      return country.translateLanguage;
    } else {
      return ["en", "hi"];
    }
  };

  const languages = language
    ? JSON.parse(language.value)?.translateLanguage
    : getLanguage();

  useEffect(() => {
    var timeoutId;

    if (!translateRef.current?.childNodes?.length > 0) {
      const activateTranslate = () => {
        try {
          if (!scriptRef.current) {
            const addScript = document.createElement("script");
            addScript.src =
              "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            scriptRef.current = addScript;
            document.body.appendChild(addScript);
          }
          if (
            !(translateRef.current?.childNodes.length > 0) &&
            window?.google?.translate
          ) {
            window.googleTranslateElementInit =
              new window.google.translate.TranslateElement(
                {
                  pageLanguage: "en",
                  includedLanguages: languages.toString(),
                  autoDisplay: true,
                  // layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL
                },
                "google_translate_element"
              );
          }

          if (!translateRef.current?.childNodes.length > 0) {
            timeoutId = setTimeout(() => {
              activateTranslate();
            }, 1000);
          }
        } catch (error) {
          console.log(error);
        }
      };

      activateTranslate();
    }
    return () => clearTimeout(timeoutId);
  }, [scriptRef, language, languages]);

  return (
    <div
      ref={translateRef}
      id="google_translate_element"
      className="!relative"
    />
  );
};

export default GoogleTranslate;